import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NarrativeHelper } from '../../utils/narrative-helper';
import { NARRATIVE_CONSTANTS } from '../../constants/narrative.constants';
import { CSVUploadResult } from '../../services/narrative-workflow.service';
import { I18nService } from '../../../../i18n/i18n.service';

@Component({
  selector: 'app-narrative-csv-uploader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './narrative-csv-uploader.component.html',
  styleUrls: ['./narrative-csv-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NarrativeCsvUploaderComponent {
  @Output() scenesLoaded = new EventEmitter<CSVUploadResult>();
  @Output() uploadError = new EventEmitter<string>();

  uploadedFileName = '';

  constructor(public i18n: I18nService) {}
  
  triggerFileInput(): void {
    const input = document.getElementById('csvFileInput') as HTMLInputElement;
    input?.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.processFile(input.files[0]);
    }
  }

  private processFile(file: File): void {
    if (!this.isValidCSVFile(file)) {
      this.uploadError.emit(this.i18n.t('vnm.err.fileTypeInvalid'));
      return;
    }

    this.uploadedFileName = file.name;

    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const csvContent = reader.result as string;
        const parseResult = NarrativeHelper.parseCSV(csvContent);

        if (parseResult.errors.length > 0) {
          this.uploadError.emit(this.i18n.t(parseResult.errors[0]));
          return;
        }

        if (parseResult.scenes.length === 0) {
          this.uploadError.emit(this.i18n.t('vnm.err.csvEmpty'));
          return;
        }

        this.scenesLoaded.emit({
          scenes: parseResult.scenes,
          fileName: this.uploadedFileName
        });
      } catch (error) {
        console.error('CSVファイルの読み込みエラー:', error);
        this.uploadError.emit(this.i18n.t('vnm.err.csvInvalidFormat'));
      }
    };

    reader.onerror = () => {
      this.uploadError.emit(this.i18n.t('vnm.err.csvReadError'));
    };

    reader.readAsText(file);
  }

  private isValidCSVFile(file: File): boolean {
    return file.type === 'text/csv' || 
           file.type === 'application/csv' ||
           file.name.toLowerCase().endsWith('.csv');
  }
}